import { createBrowserRouter } from 'react-router-dom';
import React, { Suspense } from 'react';
import { AppWithAuth, ProtectedAdminLayout } from './components/wrappers/AuthWrappers';
import Loading from './components/ui/Loading';

// Dynamically import components for code splitting
const RSSHomepage = React.lazy(() => import('./components/RSSHomepage'));
const RSSFeedItemsPage = React.lazy(() => import('./components/RSSFeedItemsPage'));
const RSSFeedItemDetailPage = React.lazy(() => import('./components/RSSFeedItemDetailPage'));
const YouTubeItemsPage = React.lazy(() => import('./components/youtube/YouTubeItemsPage'));
const YouTubeItemDetailPage = React.lazy(() => import('./components/youtube/YouTubeItemDetailPage'));
const Dashboard = React.lazy(() => import('./components/admin/Dashboard'));
const FeedsPage = React.lazy(() => import('./components/admin/FeedsPage'));
const AdminFeedItemsPage = React.lazy(() => import('./components/admin/AdminFeedItemsPage'));
const AdminLoginPage = React.lazy(() => import('./components/admin/AdminLoginPage'));
const ProtectedContent = React.lazy(() => import('@/components/admin/ProtectedContent'));
const AuthTestPage = React.lazy(() => import('@/components/admin/AuthTestPage'));
const WorkerPage = React.lazy(() => import('./components/admin/WorkerPage'));
const WorkerTerminal = React.lazy(() => import('./components/admin/WorkerTerminal'));
const CategoryPage = React.lazy(() => import('./components/admin/CategoryPage'));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppWithAuth />,
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loading />}>
            <RSSHomepage />
          </Suspense>
        )
      },
      {
        path: 'feed/:feedId',
        element: (
          <Suspense fallback={<Loading />}>
            <RSSFeedItemsPage />
          </Suspense>
        )
      },
      {
        path: 'youtube/:feedId',
        element: (
          <Suspense fallback={<Loading />}>
            <YouTubeItemsPage />
          </Suspense>
        )
      },
      {
        path: 'youtube/item/:itemId',
        element: (
          <Suspense fallback={<Loading />}>
            <YouTubeItemDetailPage />
          </Suspense>
        )
      },
      {
        path: 'feed/:feedId/item/:itemId',
        element: (
          <Suspense fallback={<Loading />}>
            <RSSFeedItemDetailPage />
          </Suspense>
        )
      }
    ]
  },
  {
    path: '/admin/login',
    element: (
      <Suspense fallback={<Loading />}>
        <AdminLoginPage />
      </Suspense>
    )
  },
  {
    path: '/admin',
    element: <ProtectedAdminLayout />,
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loading />}>
            <Dashboard />
          </Suspense>
        )
      },
      {
        path: 'feeds',
        element: (
          <Suspense fallback={<Loading />}>
            <FeedsPage />
          </Suspense>
        )
      },
      {
        path: 'feeds/:id/content',
        element: (
          <Suspense fallback={<Loading />}>
            <AdminFeedItemsPage />
          </Suspense>
        )
      },
      {
        path: 'feeds/:sourceId/content/:itemId',
        lazy: () => import('@/components/admin/AdminFeedItemContentPage'),
      },
      {
        path: 'protected',
        element: (
          <Suspense fallback={<Loading />}>
            <ProtectedContent />
          </Suspense>
        )
      },
      {
        path: 'auth-test',
        element: (
          <Suspense fallback={<Loading />}>
            <AuthTestPage />
          </Suspense>
        )
      },
      {
        path: 'workers',
        element: (
          <Suspense fallback={<Loading />}>
            <WorkerPage />
          </Suspense>
        )
      },
      {
        path: 'worker/terminal/:workerId',
        element: (
          <Suspense fallback={<Loading />}>
            <WorkerTerminal />
          </Suspense>
        )
      },
      {
        path: 'categories',
        element: (
          <Suspense fallback={<Loading />}>
            <CategoryPage />
          </Suspense>
        )
      }
      // Additional admin routes can be added here
    ]
  }
]);
